<template>
    <div class="container-fluid public-view" style="height: 100%;">
        <div class="row" style="height: 100%;">
            <div class="public-side" v-bind:style="{ backgroundSize: 'cover', backgroundImage: `url('${backImg}')` }">
                <div class="public-logo">
                    <img src="../assets/infinite-logo-white.svg" />
                </div>
            </div>
            <div class="public-main">
                <div id="main-tabs" class="scroll-y">
                    <div v-if="tempLock" class="tab-content">
                        <div class="panel">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <h1 class="public-header">Too many invalid attempts</h1>
                                    <div class="public-description">
                                        Your account has been temporarily locked due to too many invalid attempts. Please try again in a few minutes<br/>
                                        <br/>
                                        <router-link to="/login">Return to login</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="tab-content">
                        <mfa-ask-for-method v-if="askForMethod" :uid="uid" :mfaResult="result" v-on:mfa-complete="mfaComplete" />
                        <div v-else class="panel">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <h1 class="public-header">Let's verify this is you</h1>
                                    <div class="public-description">
                                        <template v-if="emailOnly">
                                            A code will be sent to the following email address: {{ email }}
                                        </template>
                                        <template v-else>
                                        <div class="row">
                                            Please select one of the following methods to validate your identity. A code will be sent to the selected destination
                                        </div>
                                        <div class="row mt-4">
                                            <ul style="list-style-type: none;" class="ml-0 ml0">
                                                <li>
                                                    <input type="radio" class="attn-radio" name="destination" :value="email" v-model="destination" id="rbEmail" :disabled="sent" />
                                                    <label for="rbEmail">{{ email }}</label>
                                                </li>
                                                <li v-for="p in phone" :key="p">
                                                    <input :id="p" type="radio" class="attn-radio" name="destination" :value="p" v-model="destination" :disabled="sent" />
                                                    <label :for="p">{{ p }}</label>
                                                </li>
                                            </ul>
                                        </div>
                                        </template>
                                        <div v-if="!sent" class="row">
                                            <button :disabled="!destination" class="btn btn-public btn-block" @click.prevent="sendCode">Send Code</button>
                                        </div>
                                        <template v-else>
                                            <div class="form-group">
                                                <div class="mt-4">
                                                    <label for="txtCode">Enter Code</label>
                                                    <input type="text" class="form-control" id="txtCode" v-model="code" autocomplete="off" />
                                                </div>
                                                <div class="mt-2">
                                                    <button class="btn btn-public btn-block" type="submitCode" @click.prevent="login">Submit Code</button>
                                                </div>
                                                <div class="mt-3">
                                                    <span style="font-size:0.9rem">
                                                        If you did not receive your code then <a href="#" @click.prevent="initialState">click here to try again</a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="mt-4" v-if="invalidOtp">
                                                <span style="font-size:0.9rem">
                                                    The code entered was invalid. Please try again or <a href="#" @click.prevent="sendCode">click to resend</a>
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios';
    import sideBackPic from '../assets/background-forest-blue.jpg'
    import { romeApi } from './utils/rome-api';
    import auth from '../auth';
    import loginMixin from './login-mixin';
    import MfaAskForMethod from './MfaAskForMethod.vue'
    import { toastService } from '../framework';

    export default {
        components: { MfaAskForMethod },
        mixins: [loginMixin],
        props: {
            email: { type: String },
            phone: { type: Array },
            uid: { type: String },
            username: { type: String },
            password: { type: String }
        },
        data() {
            return {
                backImg: sideBackPic,
                destination: null,
                code: null,
                sent: false,
                result: {},
                askForMethod: false
            }
        },
        computed: {
            emailOnly() {
                return this.email && !this.phone;
            },
            invalidOtp() {
                return this.result.error && this.result.error == 'otp';
            },
            tempLock() {
                return this.result.error && this.result.error == 'mfa_lock';
            }
        },
        created() {

            if(!this.uid)
                this.$router.push('/');

            this.initialState();


        },
        methods: {
            initialState() {
                this.code = null;
                this.sent = false;

                if(this.emailOnly)
                    this.destination = this.email;
                else
                    this.destination = null;
            },
            async login() {
                let result = await auth.verifyMfa(this.username, this.password, this.code);
                this.result = result;

                if(this.invalidOtp || this.tempLock)
                    return;
                
                if(result.userInfo.mfaMethod == null) {
                    this.askForMethod = true;
                }
                else if(result.authenticated) {
                    await this.mfaComplete();
                }
            },
            async mfaComplete() {
                await auth.mfaComplete(this.result);
                await this.goToRecent();
            },
            async sendCode() {
                this.code = null;
                try {
                    var api = Axios.create({ baseURL: romeApi.baseURL });
                    var method = this.destination.startsWith('(***)') ? 'phone' : 'email';
                    await api.post(`mfa/send-code`, { method, destination: this.destination, userId: this.uid });
                    this.result = {};
                    this.sent = true;
                }
                catch(error) {
                    let errorMessage = error.response && error.response.data.ErrorMessage
                        ? error.response.data.ErrorMessage : 'Error sending security code';

                    toastService.error(errorMessage, '');
                }
            }
        }
        
    }
</script>

<style lang="scss" scoped>
button:disabled:hover {
    opacity: 0.65;
}

.attn-radio {
    opacity: 0;
    position: absolute;
}

.attn-radio:checked+label:before {
    background: #4a4a4a;
    box-shadow: inset 0 0 0 0.2rem #fff;
}

.attn-radio+label:before {
    content: "";
    background: transparent;
    border: .125rem solid #4a4a4a;
    display: inline-block;
    vertical-align: middle;
    width: 1.25rem;
    height: 1.25rem;
    padding: .125rem;
    margin-right: 1rem;
    text-align: center;
    border-radius: 50%;
    margin-top: -.25rem;
}

.attn-radio,
.attn-radio+label {
    display: inline-block;
    margin: 0.5rem;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/framework/MfaChallenge.vue